const GET_STORY = `query GetStory($skillIds: [String]!, $filter: StoryGuideFilter) {
  getStoryGuide(skillIds: $skillIds, filter: $filter) {
    activityType
    title
    skills
    storyId
  }
}`;

export default GET_STORY;
